import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { SherpaCustomersTenantsControllerModule } from './SherpaCustomersTenantsController';

SherpaCustomersController.$inject = ['$scope', '$state'];
function SherpaCustomersController($scope, $state) {
  const ctrl = {
    tab: 'tenants',
    init: function () {
      $scope.$emit('Application::contentTitleChange', {
        title: 'Customers',
      });

      if ($state.params && $state.params.list) {
        switch ($state.params.list) {
          case 'visitors':
          // falls through
          case 'tenants':
            this.tab = $state.params.list;
            break;
        }
      }
    },
    setTab: function (tab) {
      this.tab = tab;
    },
  };

  $scope.sherpaCustomers = ctrl;
  ctrl.init();
}

export const SherpaCustomersControllerModule = angular
  .module('acme.view.application.sherpa.customers.controllers', [
    uiRouter,
    'acme.view.application.sherpa.customers.users.controllers',
    SherpaCustomersTenantsControllerModule,
  ])
  .controller('SherpaCustomersController', SherpaCustomersController).name;
